import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS } from 'react-admin';
//import {auth_url} from './url.js'
//import _ from 'lodash';

function deconnexion_clear(){
        localStorage.removeItem('token');
        localStorage.removeItem('roles');
        localStorage.removeItem('fullname');
      
        localStorage.removeItem('clone');
        localStorage.removeItem('tauxFG');
        localStorage.removeItem('tauxUSD');
        localStorage.removeItem('user_id');
        localStorage.removeItem('adrCampagnes');

        
        /*
        localStorage.removeItem('adrCampagnes');
        localStorage.removeItem('sender_id');
        localStorage.removeItem('receiver_id');
        */
}

const Authentification= (type, params) => {
    // called when the user attempts to log in
    if (type === AUTH_LOGIN) {
        const { username, password } = params;

        const request = new Request(process.env.REACT_APP_AUTH_URL, {
            method: 'POST',
            body: JSON.stringify({ username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });

        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                //console.log(response);

                return response.json();
            })
            .then(({ accessToken,id,roles ,taux_dollar,fullname,taux_fg,adrCampagnes}) => {

                localStorage.setItem('token', accessToken);
                localStorage.setItem('user_id', id);
                localStorage.setItem('fullname', fullname);
                localStorage.setItem('roles',JSON.stringify(roles) );
                localStorage.setItem('tauxFG', JSON.stringify(taux_fg));
                localStorage.setItem('tauxUSD', JSON.stringify(taux_dollar));
                localStorage.setItem('adrCampagnes',JSON.stringify(adrCampagnes));


                return Promise.resolve();
            });
    }

    // called when the user clicks on the logout button
    if (type === AUTH_LOGOUT) {

        deconnexion_clear();

        return Promise.resolve();
    }
    // called when the API returns an error
    if (type === AUTH_ERROR) {
        const { status } = params;
        if (status === 401 || status === 403) {
            deconnexion_clear();

            return Promise.reject();
        }
        return Promise.resolve();
    }
    // called when the user navigates to a new location
    if (type === AUTH_CHECK) {
        
        return localStorage.getItem('token')
            ? Promise.resolve()
            : Promise.reject();
    }

    if (type === AUTH_GET_PERMISSIONS) {
        const token = localStorage.getItem('token');
        if (!token) {
            deconnexion_clear();

            //return Promise.resolve('guest');
            return Promise.reject();
        }

        //const roles = 'ag_exp';
        const roles = localStorage.getItem('roles');
        //console.log(roles);
        return Promise.resolve(roles);
    }
    return Promise.reject('Unknown method');
};

export default Authentification;